import { useParams } from "react-router";
import Wizard from "../../lib/wizard/Wizard";
import RecallStep1 from "./RecallStep1";
import RecallStep2 from "./RecallStep2";
import RecallStep3 from "./RecallStep3";
import { useEffect, useState } from "react";
import { httpGet } from "../../../modules/Backend";
import { HttpStatusCode } from "axios";



export default function RecallsWizard() {
    const [initialData, setInitialData] = useState<any>()
    const { recallId } = useParams();

    async function checkCanEdit(id: string) {
        const result = await httpGet(`api/recalls/canEdit?id=${id}`)
        if(result.status !== HttpStatusCode.Ok || !result.data?.canEdit){
            window.history.back()
            return false
        }
        return true
    }

    async function getData(id: string) {
        const result = await httpGet(`api/recallAutoSaves/get?id=${id}`)
        if(result.status !== HttpStatusCode.Ok){
            window.history.back()
            return
        }

        if (result) {
            setInitialData(result.data)
        }
    }

    useEffect(() => {
        if (recallId) {
            checkCanEdit(recallId).then(canEdit => {
                if (canEdit) {
                    getData(recallId)
                }
            })
        } else {
            setInitialData({})
        }
    }, [])

    // If step 1 is readonly (has recallId), skip to step 2
    const isStep1Readonly = !!initialData?.recallId;
    const initialStep = isStep1Readonly ? 1 : 0;

    return (
        initialData &&
        <div className="recall-wizard__wrapper">
            <Wizard initialData={initialData} initialStep={initialStep}>
                <RecallStep1 displayName="Recall options" />
                <RecallStep2 displayName="Select inventory" />
                <RecallStep3 displayName="Delivery" />
            </Wizard>
        </div>

    )
}